import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { templateVersionsUrl } from './helpers';
import { IDocumentAssemblerTemplateVersionListResponse } from './types';

export const useDocumentAssemblerTemplateVersions = (
  templateId: string | null
) => {
  const { data, error, isLoading, mutate } =
    useSWR<IDocumentAssemblerTemplateVersionListResponse>(
      templateId ? templateVersionsUrl(templateId) : null,
      SWRFetcher({ method: 'GET' })
    );

  return {
    templateVersions: data?.templateVersions,
    count: data?.count,
    error,
    isLoading,
    mutate,
  };
};
